module.exports = __webpack_public_path__ + "img/textbg.d19d1b29.png";